import {Button} from 'react-bootstrap'
import DeleteConfirmationModal from './DeleteWarning'
import {KTIcon} from '../_metronic/helpers'

function DeleteButton({...rest}) {
  return (
    <DeleteConfirmationModal {...rest}>
      <Button variant="outline-secondary" size="sm" className="px-2">
        <KTIcon iconName="trash" className="text-danger fs-2 p-0" />
      </Button>
    </DeleteConfirmationModal>
  )
}

export default DeleteButton
